import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/localisation/i18n";
import "./assets/styles/base/typography.scss";
import "./config/Grid/Grid.scss";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { BackdropStateProvider } from "./components/BackDrop/BackDropProvider";
import { useVenuesDataStore } from "./store/useVenuesDataStore";
import { applyThemeColors, setThemeLoading } from "./helpers/applyThemeColors";

// Theme bootstrap (runs before first paint):
// - Returning visitor with persisted colors → apply them immediately.
// - First visit → render in grayscale until the colors endpoint responds
//   (handled in HomePage) or the fallback theme is applied.
const persistedColor = useVenuesDataStore.getState().color;
if (persistedColor) {
  applyThemeColors(persistedColor);
} else {
  setThemeLoading(true);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <BackdropStateProvider>
        <App />
      </BackdropStateProvider>
    </BrowserRouter>
  </QueryClientProvider>,
);
